import AbstractRestApi from '@/api/RestApi/AbstractRestApi'

class UserAddresses extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/user-addresses'
    }
}

export default new UserAddresses()
